import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import manufacturingImage from '../../../../../../Assets/Smart Manufacturing Solutions.png';
import aerospaceImage from '../../../../../../Assets/Factory and Industry.png';
import automotiveImage from '../../../../../../Assets/automotive2.png';
import equipmentImage from '../../../../../../Assets/Equipments Solutions.png';
import electronicsImage from '../../../../../../Assets/InforPage/Infor_2.jpg';
import distributionImage from '../../../../../../Assets/WareHouse (2).png';

const industries = [
  {
    name: 'Manufacturing',
    image: manufacturingImage,
    description: 'Connect production planning, shop-floor operations, quality, and supply across your manufacturing network.',
  },
  {
    name: 'Aerospace & Defense',
    image: aerospaceImage,
    description: 'Support complex programs with stronger project control, quality, and product traceability.',
  },
  {
    name: 'Automotive Suppliers',
    image: automotiveImage,
    description: 'Coordinate supplier schedules, production requirements, costing, and inventory.',
  },
  {
    name: 'Industrial Equipment',
    image: equipmentImage,
    description: 'Manage engineer-to-order production, project delivery, service, and spare parts.',
  },
  // {
  //   name: 'High-Tech Manufacturing',
  //   image: electronicsImage,
  //   description: 'Connect component visibility, engineering changes, quality, and fulfillment.',
  // },
  {
    name: 'Wholesale & Distribution',
    image: distributionImage,
    description: 'Improve inventory visibility, warehouse workflows, and order fulfillment.',
  },
];

const LNIndustryCarousel = () => {
  const carouselRef = useRef(null);

  const moveCarousel = (direction) => {
    const carousel = carouselRef.current;
    const firstCard = carousel?.firstElementChild;
    if (!carousel || !firstCard) return;

    const cardWidth = firstCard.getBoundingClientRect().width;
    const gap = Number.parseFloat(window.getComputedStyle(carousel).columnGap) || 0;
    const distance = cardWidth + gap;
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;

    carousel.scrollTo({
      left: direction === 'next'
        ? (carousel.scrollLeft >= maxScroll - 1 ? 0 : carousel.scrollLeft + distance)
        : (carousel.scrollLeft <= 1 ? maxScroll : Math.max(0, carousel.scrollLeft - distance)),
      behavior: 'smooth',
    });
  };

  return (
    <section className="px-5 py-10 sm:px-6 sm:py-12 lg:px-10" style={{ backgroundColor: '#F7F7F7', fontFamily: "'Be Vietnam Pro', sans-serif" }}>
      <div className="mx-auto max-w-7xl">
        <h2 className="text-center text-[32px] font-semibold leading-[48px]" style={{ color: '#183762' }}>
          Industries We Serve
        </h2>

        <div
          ref={carouselRef}
          className="mt-9 flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:mt-11"
          aria-label="Industries we serve"
        >
          {industries.map((industry) => (
            <article
              key={industry.name}
              className="flex min-h-[376px] w-full flex-none snap-start flex-col overflow-hidden rounded-md sm:basis-[calc(50%-8px)] lg:basis-[calc(25%-12px)]"
              style={{ backgroundColor: '#FFFFFF' }}
            >
              <img src={industry.image} alt={industry.name} className="h-40 w-full shrink-0 object-cover" loading="lazy" />
              <div className="flex flex-1 flex-col p-4 sm:p-5">
                <h3 className="text-lg font-semibold leading-tight sm:text-xl" style={{ color: '#183762' }}>
                  {industry.name}
                </h3>
                <p className="mt-3 flex-1 text-base font-normal" style={{ color: '#212121' }}>
                  {industry.description}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-7 flex items-center justify-center gap-3">
          <button
            type="button"
            onClick={() => moveCarousel('previous')}
            aria-label="Previous industries"
            className="flex h-9 w-9 items-center justify-center rounded-full transition-opacity hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2"
            style={{ backgroundColor: '#667085', color: '#FFFFFF' }}
          >
            <ChevronLeft size={22} aria-hidden="true" />
          </button>
          <button
            type="button"
            onClick={() => moveCarousel('next')}
            aria-label="Next industries"
            className="flex h-9 w-9 items-center justify-center rounded-full transition-opacity hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2"
            style={{ backgroundColor: '#667085', color: '#FFFFFF' }}
          >
            <ChevronRight size={22} aria-hidden="true" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default LNIndustryCarousel;
